import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import localeJa from '@angular/common/locales/ja';
import { LOCALE_ID, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { ConsultingReservationNoCalendarComponent } from 'src/app/components/consulting-reservation-no-calendar/consulting-reservation-no-calendar.component';
import { ConsultingReservationComponent } from 'src/app/components/consulting-reservation/consulting-reservation.component';
import { CounselingButtonComponent } from 'src/app/components/counseling-button/counseling-button.component';
import { DiagnosisResultComponent } from 'src/app/components/diagnosis-result/diagnosis-result.component';
import { DiagnosisComponent } from 'src/app/components/diagnosis/diagnosis.component';
import { FairFormComponent } from 'src/app/components/fair-form/fair-form.component';
import { FairForm2Component } from 'src/app/components/fair-form2/fair-form2.component';
import { FormGroupComponent } from 'src/app/components/form-group/form-group.component';
import { LpConsultingReservationComponent } from 'src/app/components/lp-consulting-reservation/lp-consulting-reservation.component';
import { ModalCounselingReservationComponent } from 'src/app/components/modal-counseling-reservation/modal-counseling-reservation.component';
import { RequestMaterial } from 'src/app/components/request-material/request-material..';
import { ShindanFormComponent } from 'src/app/components/shindan-form/shindan-form.component';
import { UrlInterceptor } from 'src/app/config/url.interceptor';

if (!customElements.get('consulting-reservation')) {
  (async () => {
    registerLocaleData(localeJa);
    const app = await createApplication({
      providers: [
        provideHttpClient(
          withInterceptors([UrlInterceptor])
        ),
        { provide: LOCALE_ID, useValue: 'ja-JP' },
        { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+09:00' } },
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection()
      ]
    });

    // 競合対策: ほぼ同時に main.js が 2 回実行された場合の二重防止
    if (customElements.get('consulting-reservation')) {
      console.warn(`[consulting-reservation] already defined after application creation: consulting-reservation`);
      app.destroy();
      return;
    }

    const register = (name: string, component: any) => {
      if (customElements.get(name)) {
        return;
      }

      customElements.define(name, createCustomElement(component, {
        injector: app.injector
      }));
    };

    register('consulting-reservation', ConsultingReservationComponent);
    register('consulting-reservation-no-calendar', ConsultingReservationNoCalendarComponent);
    register('lp-consulting-reservation', LpConsultingReservationComponent);
    register('shindan-form', ShindanFormComponent);
    register('diagnosis-input', DiagnosisComponent);
    register('diagnosis-result', DiagnosisResultComponent);
    register('service-site-form-group', FormGroupComponent);
    register('fair-form', FairFormComponent);
    register('fair-form2', FairForm2Component);
    register('counseling-button', CounselingButtonComponent);
    register('modal-counseling-reservation', ModalCounselingReservationComponent);
    register('request-material', RequestMaterial);

    const searchParmas = new URLSearchParams(window.location.search);
    if (window.location.search.includes('utm')) {
      sessionStorage.setItem('search-parameter', window.location.search.replace('?', ''));
    }
    if (searchParmas.has('utm_source')) {
      sessionStorage.setItem('utm_source', searchParmas.get('utm_source')!);
    }
    if (searchParmas.has('utm_medium')) {
      sessionStorage.setItem('utm_medium', searchParmas.get('utm_medium')!);
    }
    if (searchParmas.has('utm_campaign')) {
      sessionStorage.setItem('utm_campaign', searchParmas.get('utm_campaign')!);
    }

    const form = document.querySelector('.mw_wp_form') as HTMLFormElement;
    if (form) {
      form.addEventListener('submit', (e) => {
        const target = e.target as HTMLFormElement;
        const search = sessionStorage.getItem('search-parameter');
        if (search !== null) {
          const hidden = target.querySelector('input[name="search-parameter"]') as HTMLInputElement | null;
          if (hidden !== null) {
            hidden.value = search;
          }
        }
        const fd = new FormData(target);
        const value = {
          countries: fd.getAll('country[data][]'),
          budget: fd.get('budget') as string,
          skill: fd.get('skill') as string,
          lastNameKana: fd.get('lastname-furigana') as string,
          firstNameKana: fd.get('firstname-furigana') as string,
          phoneNumber: fd.get('tell') as string,
          email: fd.get('mail') as string,
          lpType: fd.get('lpType') as string
        };
        sessionStorage.setItem('wp-form', JSON.stringify(value));
      });
    }
  })();
}
